module.exports = __webpack_public_path__ + "static/img/4_1.2bbe39f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/4_1.png
// module id = piXF
// module chunks = 44